var chunkMapping = {
	"webpack_container_remote_documentation_Routes": [
		47264
	]
};
var idToExternalAndNameMapping = {
	"47264": [
		"default",
		"./Routes",
		27308
	]
};
var idToRemoteMap = {
	"47264": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 27308
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}